import { render } from "./Sale_Details.vue?vue&type=template&id=3800101e&scoped=true"
import script from "./Sale_Details.vue?vue&type=script&lang=js"
export * from "./Sale_Details.vue?vue&type=script&lang=js"

import "./Sale_Details.vue?vue&type=style&index=0&id=3800101e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3800101e"]])

export default __exports__